import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-barber-bg grain relative flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-barber-muted hover:text-barber-gold text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
        <div className="bg-barber-surface border border-barber-gold/30 p-8 sm:p-10">
          <div className="mb-4">
            <img src="/barber-parlor-logo.png" alt="The Barber Parlor" className="h-14 w-auto" />
          </div>
          <p className="text-barber-muted text-sm mb-8">Barber dashboard — sign in to manage your schedule.</p>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label className="text-barber-muted">Email</Label>
              <Input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 rounded-none bg-barber-bg border-barber-gold/20 text-barber-cream focus-visible:ring-barber-gold"
                required
              />
            </div>
            <div>
              <Label className="text-barber-muted">Password</Label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 rounded-none bg-barber-bg border-barber-gold/20 text-barber-cream focus-visible:ring-barber-gold"
                required
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-barber-red text-sm">
                {error}
              </p>
            )}
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full rounded-none btn-gold font-semibold py-6"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
